module.exports = __webpack_public_path__ + "img/trivia-853.cd3ed7de.png";